import EventsCta from "../eventsExperiences/EventsCta";
// Placeholder photo until the final celebrity image is ready.
import ctaImage from "../../assets/images/eventsExperiences/services/talent.jpg";

// Same call-to-action as the other service pages; the button goes to Contact Us.
const CelebCta = () => (
  <EventsCta
    image={ctaImage}
    eyebrow="Let's create together"
    title="Have a"
    accent="celebrity in mind?"
    intro="Tell us what you're planning. We'll help you find the right celebrity and bring the entire collaboration to life."
    points={[]}
  />
);

export default CelebCta;
